import React from "react";
import "./Sidebar.css";
import { NavLink } from "react-router-dom";
import useUserStore from "../../store/useUserStore";
import {
  LayoutDashboard,
  ShoppingCart,
  UserCheck,
  ImageIcon,
  UsersRound,
  Users,
  Settings,
} from "lucide-react";

const Sidebar = () => {
  const parseTokenPayload = () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return {};
      const payload = token.split(".")[1];
      if (!payload) return {};
      return JSON.parse(atob(payload));
    } catch (_error) {
      return {};
    }
  };

  const buildDisplayNameFromEmail = (email = "") => {
    if (!email || typeof email !== "string") return "Admin User";
    const localPart = email.split("@")[0] || "";
    const words = localPart
      .replace(/[._-]+/g, " ")
      .trim()
      .split(" ")
      .filter(Boolean)
      .slice(0, 2);

    if (!words.length) return "Admin User";

    return words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const menuItems = [
    {
      title: "Dashboard",
      icon: <LayoutDashboard className="menu-icon" />,
      path: "/dashboard",
    },
    {
      title: "Orders",
      icon: <ShoppingCart className="menu-icon" />,
      path: "/orders",
    },
    {
      title: "Vendor Approvals",
      icon: <UserCheck className="menu-icon" />,
      path: "/vendor-approvals",
    },
    {
      title: "Web Page Images",
      icon: <ImageIcon className="menu-icon" />,
      path: "/webpage-images",
    },
    {
      title: "Managements",
      icon: <UsersRound className="menu-icon" />,
      path: "/managements",
    },
    {
      title: "Staff Managements",
      icon: <Users className="menu-icon" />,
      path: "/staff-managements",
    },
    {
      title: "Settings",
      icon: <Settings className="menu-icon" />,
      path: "/settings",
    },
  ];

  const { user } = useUserStore();
  const tokenPayload = parseTokenPayload();

  const firstName =
    user?.firstName || tokenPayload?.firstName || tokenPayload?.given_name || "";
  const lastName =
    user?.lastName || tokenPayload?.lastName || tokenPayload?.family_name || "";
  const email = user?.email || tokenPayload?.email || "";

  const fallbackName = buildDisplayNameFromEmail(email);
  const fullName =
    `${firstName} ${lastName}`.trim() || fallbackName;

  const initials =
    fullName
      .split(" ")
      .filter(Boolean)
      .map((part) => part[0])
      .join("")
      .slice(0, 2)
      .toUpperCase() || "AU";

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="sidebar-brand-dot" />
        <div>
          <p className="sidebar-brand-label">Admin Panel</p>
          <h2 className="sidebar-brand-title">Keejani</h2>
        </div>
      </div>

      <nav className="nav-menu">
        {menuItems.map((item, index) => (
          <NavLink
            to={item.path}
            key={index}
            className={({ isActive }) =>
              `menu-item ${isActive ? "active" : ""}`
            }
          >
            {item.icon}
            <span className="menu-title">{item.title}</span>
          </NavLink>
        ))}
      </nav>

      <div className="profile-section">
        <div className="profile-img">{initials}</div>
        <div className="profile-info">
          <h4>{fullName}</h4>
          <p>{email || "admin@keejani.com"}</p>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
